<template>
    <a href="https://www.asca.org/wp-content/uploads/2019/09/bylaws.pdf" target="_blank">Bylaws</a>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({ name: "BylawsLink" });
</script>